import { lazyLoad } from "utils/loadable";

const LearnPage = lazyLoad(
  () => import("./index"),
  (module) => module.LearnPage,
  {
    fallback: (
      <div>
        <p>Loading....</p>
      </div>
    ),
  }
);

export default LearnPage;
